import React from "react";
import "./portfolio.scss";
// import { Link } from "react-router-dom";
import { Project } from "./Projects";

const Portfolio = () => {
  // const [current, setCurrent] = useState(2);
  // const Red = () => {
  //   setCurrent(2);
  //   console.log(current);
  // };
  // const Redo = () => {
  //   setCurrent(2);
  //   console.log(current);
  // };
  // const Word = () => {
  //   setCurrent(1);
  //   console.log(current);
  // };
  // const Gfx = () => {
  //   setCurrent(3);
  //   console.log(current);
  // };

  return (
    <div className="portfolio" id="portfolio">
      <div className="txt">
        <h1>My Work</h1>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veritatis, dicta!</p>
      </div>
      {/* <div className="btns gride">
        <button onClick={Redo}>html/css/js</button>
        <button onClick={Red}>REact</button>
        <button onClick={Word}>WORDPRESS</button>
        <button onClick={Gfx}>Graphics</button>
      </div> */}
      <div className="folio">
        {Project.map((i) => {
          return (
            // <>
            //   {i.type === current && (
                <a href={i.link} className="project" key={i.id} target=''>
                  <img src={i.Image} alt={i.projectName} />
                  <div className="details">
                    <h2>{i.projectName}</h2>
                    <h4>{i.stack}</h4>
                  </div>
                </a>
            //   )}
            // </>
          );
        })}
      </div>

      <div className="clients"></div>
    </div>
  );
};

export default Portfolio;
